import React from "react";
import { IInstrumentDetails } from '../../models/measurement/InstrumentDetails';
import { IKeyedInDetails } from '../../models/measurement/KeyedInDetails';
import { ICalculatedDetails } from "../../models/measurement/CalculatedDetails";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner } from "@abb/abb-common-ux-react";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import Utility from "../shared/Utility";

interface IPropertyTable {
    details?: boolean;
    keyedInSection?: boolean;
    calculatedSection?: boolean;
    meauredSection?: boolean;
    selectedInstrumentDetail: IInstrumentDetails;
    selectedKeyedInDetails?: IKeyedInDetails;
    selectedCalculatedDetails?: ICalculatedDetails;
    selectedDirection?: any;
    thresholdSettings: IThresholdSettings[];
}

interface IPropertyState {
    totalmeasuredproperty: any[];
    measuredproperty: any[];
}

export default class GraphPropertyTable extends React.Component<IPropertyTable, IPropertyState> {

    private _hasData: boolean = true;
    private _page: any = 1;

    constructor(props: IPropertyTable) {
        super(props);

        this.state = {
            totalmeasuredproperty: [],
            measuredproperty: [],
        }
    }

    componentDidMount() {
        this.measuredRow();
        this._hasData = true;
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.selectedInstrumentDetail != this.props.selectedInstrumentDetail) {
            this.measuredRow();
            this._hasData = true;
        }
    }

    private measuredRow() {
        const items: any[] = [];
        const selectedInstrumentDetail = this.props.selectedInstrumentDetail;
        let countData = selectedInstrumentDetail.countData.find(x => x.selected);
        if (!countData) {
            countData = selectedInstrumentDetail.countData[0];
            countData.selected = true;
        }
        let selectedPosition = selectedInstrumentDetail.positionCount.find(x => x.selected);
        if (!selectedPosition) {
            selectedPosition = selectedInstrumentDetail.positionCount[0];
        }

        let selectedDirection: any;
        if (countData !== undefined) {
            selectedDirection = countData.directions.find(x => x.selected);
        }
        if (!selectedDirection) {
            selectedDirection = countData?.directions[0];
            selectedDirection.selected = true;
        }

        if (this.props.details) {
            const filteredProps = Utility.getUniquePropertiesFromList(selectedInstrumentDetail.properties);
            
            let properties = [];
            if (selectedDirection !== undefined) {
                properties = filteredProps.filter(x => selectedDirection.name === "All" ? x : x.directionId === selectedDirection.id);
            } else {
                properties = filteredProps;
            }

            properties.map((property: any, index: any) => {
                let mean = null;
                let statistics;

                if (selectedInstrumentDetail.isAutoLine) {
                    if (selectedInstrumentDetail.statistics !== null || selectedInstrumentDetail.statistics !== undefined || selectedPosition !== undefined) {
                        statistics = selectedInstrumentDetail.statistics.reverse().find(x => x.propertyId === property.id &&
                            x.position === selectedPosition.position)
                        statistics !== undefined ? mean = statistics.mean : null

                    }
                } else {
                    if (selectedInstrumentDetail.statistics !== null || selectedInstrumentDetail.statistics !== undefined) {
                        if (selectedPosition !== undefined) {
                            statistics = selectedInstrumentDetail.statistics.find(x => x.propertyId === property.id &&
                                x.position === selectedPosition.position && x.directionId === property.directionId);
                            statistics !== undefined ? mean = statistics.mean : null
                        }
                    }
                }
                const cpProperty = this.props.selectedInstrumentDetail.currentMeasuringProperty;
                const cpPosition = this.props.selectedInstrumentDetail.currentMeasuringPosition;
                if (selectedPosition !== undefined) {
                    items.push(<tr className={property.id === cpProperty && selectedPosition.position === cpPosition ? "normal-class active-class" : "normal-class"}
                        key={index}>
                        <td className="text-ellipsis" style={{ paddingBottom: "127px" }}>{property.name} </td>
                        <td style={{ paddingBottom: "127px" }}>{property.unit || ""}</td>
                        {(mean != null && !isNaN(mean))
                            ? <td style={{ paddingBottom: "127px", color: this.props.thresholdSettings.find(x => x.name === "Mean").colorCode }}>{mean.toFixed(property.decimals)}</td>
                            : <td style={{ paddingBottom: "127px", color: this.props.thresholdSettings.find(x => x.name === "Reject Limit").colorCode }}>{CONSTANTS.NOTCONSIDEREDFORCALC}</td>
                        }
                    </tr>)
                }
            })
        } else {
            const filteredProps = Utility.getUniquePropertiesFromList(selectedInstrumentDetail.properties);
            let properties: any[] = []
            if (selectedDirection !== undefined) {
                properties = filteredProps.filter(x => selectedDirection.name === "All" ? x : x);
            } else {
                properties = filteredProps;
            }


            this.setState({
                totalmeasuredproperty: [...properties],
                measuredproperty: [...properties.filter((item, index) => index < 5)]
            });
        }
    }

    private measuredRowData(property: any, index: any) {
        const selectedInstrumentDetail = this.props.selectedInstrumentDetail;
        const data = selectedInstrumentDetail?.propertyMeans !== undefined ? selectedInstrumentDetail?.propertyMeans : [];
        let meanV;
        if (selectedInstrumentDetail.readings.length > 0) {
            meanV = selectedInstrumentDetail.readings[0].directionMeans !== undefined ?
                selectedInstrumentDetail.readings[0].directionMeans.find(x => x.propertyId === property.id && x.directionId === property.directionId)
                : undefined;
        }

        const meanVal = meanV === undefined ? "(--)" : meanV.mean;
        const meanValue = Math.round(Number(meanVal) * 100) / 100;
        return <tr className="normal-class" key={index}>
            <td style={{ paddingBottom: "127px" }} className="text-ellipsis">{property.name} </td>
            <td style={{ paddingBottom: "127px" }}>{property.unit || ""}</td>
            {isNaN(meanValue)
                ? <td style={{ paddingBottom: "127px", color: this.props.thresholdSettings?.find(x => x.name === "Reject Limit").colorCode }}>{CONSTANTS.NOTCONSIDEREDFORCALC}</td>
                : <td style={{ paddingBottom: "127px", color: this.props.thresholdSettings?.find(x => x.name === "Mean").colorCode }}>{meanValue?.toFixed(property.decimals)}</td>
            }

        </tr>
    }


    private keyedInRow() {
        const items: any[] = [];
        if (this.props.details) {
            const selectedKeyedInDetails = this.props.selectedKeyedInDetails;
            const countData = selectedKeyedInDetails.countData.find(x => x.selected);
            const selectedPosition = selectedKeyedInDetails.positionCounts.find(x => x.selected);
            const selectedDirection = countData.directions.find(x => x.selected);
            const mean = selectedKeyedInDetails.statistics.find(x => x.directionId === selectedDirection.id &&
                x.position === selectedPosition.position
            )
            const meanVal = (mean != undefined && mean.mean != null && !isNaN(mean.mean)) ? mean.mean : CONSTANTS.NOTCONSIDEREDFORCALC;
            const meanDisplayValue = Math.round(Number(meanVal) * 100) / 100;
            items.push(<tr className="normal-class" key={Math.random()}>
                <td className="text-ellipsis" style={{ paddingBottom: "127px" }}>{this.props.selectedKeyedInDetails.name} </td>
                <td style={{ paddingBottom: "127px" }}>{this.props.selectedKeyedInDetails.unit || ""}</td>
                {isNaN(meanDisplayValue)
                    ? <td style={{ paddingBottom: "127px", color: this.props.thresholdSettings.find(x => x.name === "Reject Limit").colorCode }}>{CONSTANTS.NOTCONSIDEREDFORCALC}</td>
                    : <td style={{ paddingBottom: "127px", color: this.props.thresholdSettings.find(x => x.name === "Mean").colorCode }}>{Number(meanVal).toFixed(selectedKeyedInDetails?.decimals)}</td>
                }
            </tr>)

        } else {
            items.push(
                <tr className="normal-class" key={Math.random()}>
                    <td className="text-ellipsis" style={{ paddingBottom: "127px" }}>{this.props.selectedKeyedInDetails.name} </td>
                    <td style={{ paddingBottom: "127px" }}>{this.props.selectedKeyedInDetails.unit || ""}</td>
                    {this.props.selectedKeyedInDetails.propertyMean
                        && this.props.selectedKeyedInDetails.propertyMean.mean != null
                        && !isNaN(this.props.selectedKeyedInDetails.propertyMean.mean) 
                        ? <td style={{ paddingBottom: "127px", color: this.props.thresholdSettings.find(x => x.name === "Mean").colorCode }}>{this.props.selectedKeyedInDetails.propertyMean.mean.toFixed(this.props.selectedKeyedInDetails?.decimals)}</td>
                        : <td style={{ paddingBottom: "127px", color: this.props.thresholdSettings.find(x => x.name === "Reject Limit").colorCode }}>{CONSTANTS.NOTCONSIDEREDFORCALC}</td>
                    }
                </tr>
            )
        }

        return items;
    }

    public fetchMoreMeasured = () => {
        this._page = this._page + 1;
        const mProperty = this.state.totalmeasuredproperty.filter((item: any, index: number) => index < 5 * this._page).length;
        if (mProperty === this.state.totalmeasuredproperty.length) {
            this._hasData = false;
        }
        this.setState({
            measuredproperty: [...this.state.totalmeasuredproperty.filter((item: any, index: number) => index < 5 * this._page)]
        })
    }

    public render() {
        if (this.props.selectedKeyedInDetails !== undefined) {
            const kcountData = this.props.selectedKeyedInDetails?.countData?.find(x => x.selected);
            const kselectedDirection = kcountData?.directions?.find(x => x.selected);
        }

        return (
            <Translation>
                {
                    t =>
                        <div>

                            {this.props.meauredSection && (
                                <InfiniteScroll
                                    dataLength={this.state.measuredproperty.length} //This is important field to render the next data
                                    next={this.fetchMoreMeasured}
                                    hasMore={this._hasData}
                                    loader={<div><h6 style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center' }}><Spinner color='blue' sizeClass='medium' /></h6><div></div></div>}
                                    scrollThreshold={0.7}
                                    scrollableTarget="scrollableDivs">
                                    <table className="sampletbl">
                                        <thead>
                                            <tr>
                                                <th scope="col">{t(CONSTANTS.MODULE_PROPERTY)}</th>
                                                <th scope="col">{t(CONSTANTS.LABEL_UNIT)}</th>
                                                <th scope="col">{t(CONSTANTS.LABEL_MEAN)}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.measuredproperty.map((property: any, index: any) => {
                                                    return this.measuredRowData(property, index)
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </InfiniteScroll>
                            )}

                            {this.props.keyedInSection && (
                                <table className="sampletbl">
                                    <thead>
                                        <tr>
                                            <th scope="col">{t(CONSTANTS.MODULE_PROPERTY)}</th>
                                            <th scope="col">{t(CONSTANTS.LABEL_UNIT)}</th>
                                            <th scope="col">{t(CONSTANTS.LABEL_MEAN)}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.keyedInRow()}
                                    </tbody>
                                </table>
                            )}

                            {this.props.calculatedSection && (<table className="sampletbl">
                                <thead>
                                    <tr>
                                        <th scope="col">{t(CONSTANTS.MODULE_PROPERTY)}</th>
                                        <th scope="col">{t(CONSTANTS.LABEL_UNIT)}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="normal-class" key={Math.random()}>
                                        <td style={{ paddingBottom: "127px" }}>{this.props.selectedCalculatedDetails.name} </td>
                                        <td style={{ paddingBottom: "127px" }}>{this.props.selectedCalculatedDetails.unit || ""}</td>
                                    </tr>
                                </tbody>
                            </table>)}
                        </div>
                }
            </Translation>
        )
    }
}
